class AnnouncementBar {
    constructor(container) {
        this.container = container;
        this.init();
    }

    init() {
        this.handleSplideSlider(this.container);
    }

    handleSplideSlider(container) {
        document.addEventListener('DOMContentLoaded', function () {
            let autoplayEnabled = autoRotate;
            let autoplayCarouselSpeed = autoplaySpeed * 1000; 
            let splideType = autoplayEnabled ? 'fade' : 'fade'

            const announcementBarSlider = container.querySelector('[announcement-bar-slider]')

            new Splide(announcementBarSlider, {
                type       : splideType,
                rewind     : true,
                perPage    : 1,
                autoplay   : autoplayEnabled,
                interval   : autoplayCarouselSpeed,
                arrows     : true,
                pagination : false,
                speed      : 1000, 
            }).mount();
        });
    }
}

new AnnouncementBar (
    document.querySelector('[announcement-bar]')
)
